import { render, staticRenderFns } from "./LandingComponent.vue?vue&type=template&id=75686f4d&scoped=true&"
import script from "./LandingComponent.vue?vue&type=script&lang=js&"
export * from "./LandingComponent.vue?vue&type=script&lang=js&"
import style0 from "./LandingComponent.vue?vue&type=style&index=0&id=75686f4d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75686f4d",
  null
  
)

export default component.exports